import { Grid, Tooltip } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import { clamp } from 'lodash';
import React from 'react';
import TypeBudget from '../../../constants/simulation/typeBudget';
import type PanelProps from '../../../interfaces/simulation/panelProps';
import EpargneChart from './EpargneChart';
import './EpargnePanel.css';

const EpargneNette = ({ data, tooltip }: PanelProps) => {
	let epargneNette = 0;
	let recetteReelFonctionnement = 0;
	let taux = 0;

	if (
		!data?.transfertCpta ||
		data?.typeBudget === TypeBudget.COMPTE_ADMINISTRATIF
	) {
		epargneNette =
			(data?.epargneBrute ?? 0) - (data?.remboursementCapitalDette ?? 0);
		recetteReelFonctionnement = data?.recetteReelFonctionnement ?? 0;
		taux = clamp(
			recetteReelFonctionnement > 0
				? (epargneNette * 100) / recetteReelFonctionnement
				: 0,
			0,
			100,
		);
	}

	const chartData = [
		{
			name: 'Epargne Nette N-2',
			value:
				(data.exercicePrecedent2?.epargneBrute ?? 0) -
				(data.exercicePrecedent2?.remboursementCapitalDette ?? 0) -
				(data.exercicePrecedent2?.remboursementInteretDette ?? 0),
		},
		{
			name: 'Epargne Nette N-1',
			value:
				(data.exercicePrecedent?.epargneBrute ?? 0) -
				(data.exercicePrecedent?.remboursementCapitalDette ?? 0) -
				(data.exercicePrecedent?.remboursementInteretDette ?? 0),
		},
		{ name: 'Epargne Nette', value: epargneNette },
	];

	return (
		<Grid>
			<Grid.Row>
				<Grid.Column width={10}>
					<Tooltip
						message={tooltip}
						trigger={
							<div className="bold indicateurTitle">
								{`Epargne nette ${data?.anneeExercice}`}
							</div>
						}
						type="information"
					/>

					<br />
					<br />
					{`${data?.typeBudget === TypeBudget.COMPTE_ADMINISTRATIF ? 'Réalisations' : 'Prévisions'} :`}
					<br />
					<span data-testid="epargneNette">{formatMontant(epargneNette)}</span>
					<br />
					<br />
					<span data-testid="tauxEpargneNette">{`Taux: ${taux?.toFixed(2)}%`}</span>
				</Grid.Column>
				<Grid.Column className="epargneChartContainer" width={6}>
					<EpargneChart data={chartData} epargne={epargneNette} />
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default EpargneNette;
